// extracted by mini-css-extract-plugin
export default {"iframe":"HTMLPreview_iframe__aTD-X"};